import React, { useEffect, useState } from "react";
import Loader from "../../../common/Loader";
import RecipientRdvListItem from "./RecipientRdvListItem";
import dataService from "../../../../helpers/dataService";
import useStore from "../../../../context/useStore";
import { modalActions } from "../../../../context/actions/modalActions";
import CreateRdvOnTheFly from "../common/CreateRdvOnTheFly/CreateRdvOnTheFly";
import { EmptyState, Pill } from "../../../common/DataList";
import "./recipient-rdv.scss";

const RecipientRdv = ({
  rdvs,
  errors,
  setErrors,
  recipientId,
  getRdvs,
  isLoading,
  rdspId,
  recipient,
}) => {
  const [state, dispatch] = useStore();
  const modActions = modalActions(state, dispatch);
  const [rdvSlots, setRdvSlots] = useState([]);
  const [isLoadingSlots, setIsLoadingSlots] = useState(false);
  const [rdvSelected, setRdvSelected] = useState(null);
  const [currentRdv, setCurrentRdv] = useState(null);
  const [originSelected, setOriginSelected] = useState(null);
  const [reasonSelected, setReasonSelected] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [reportRdvOpen, setReportRdvOpen] = useState(false);
  const [isReportSiteOpen, setIsReportSiteOpen] = useState(false);
  const [deletingRdvslotCalendarId, setDeletingRdvslotCalendarId] =
    useState(null);

  useEffect(() => {
    setReasonSelected(false);
  }, [originSelected]);

  function getReportDates(rdv, siteId) {
    setReportRdvOpen(rdv.id);
    setRdvSlots([]);
    setIsSaved(false);
    setRdvSelected(null);
    setCurrentRdv(rdv);
    if (rdv.slotCalendar.type == 3) {
      //si c'est un rdv CER, on sélectionne pas de slot, on crée à la volée (CreateRdvOnTheFly)
      setRdvSlots([]);
    } else {
      setIsLoadingSlots(true);
      dataService.post(
        `slotcalendars/sites/${siteId}`,
        {
          userRecipientId: recipientId,
          slotCalendarId: rdv.slotCalendarId,
          isReport: true,
        },
        setRdvSlots,
        setErrors,
        () => setIsLoadingSlots(false)
      );
    }
  }

  function saveReportRdv(slobObjOverride = null) {
    var slotObj = {};
    var postParams = {};
    if (slobObjOverride) {
      //si c'est un rdv non issue d'un slot calendar sélectionné (onTheFly)
      slotObj = slobObjOverride;
      postParams = {
        slotsId: null,
        start: slotObj.start,
        end: slotObj.end,
        slotCalendarId: currentRdv.slotCalendarId,
        reportType: reasonSelected,
        cancelOrigin: originSelected,
        box: slotObj.box,
        site: slotObj.site,
        type: slotObj.type,
        subType: slotObj.subType,
        title: slotObj.title,
        isPhoneCall: slotObj.isPhoneCall,
      };
    } else {
      slotObj = rdvSlots.find((s) => s.id == rdvSelected);
      postParams = {
        slotsId: slotObj.slotsId,
        start: slotObj.start,
        end: slotObj.end,
        slotCalendarId: currentRdv.slotCalendarId,
        reportType: reasonSelected,
        cancelOrigin: originSelected,
        isPhoneCall: slotObj.isPhoneCall,
      };
    }

    setIsSaving(true);

    dataService.post(
      `slotcalendars/recipients/${recipientId}`,
      postParams,
      (data) => {
        setIsReportSiteOpen(false);
        setReportRdvOpen(false);
        getRdvs();
        setIsSaved(true);
      },
      setErrors,
      () => setIsSaving(false)
    );
  }

  const openRdvOnTheFlyModal = () => {
    modActions.updateModal({
      isOpen: true,
      content: (
        <CreateRdvOnTheFly
          organizationSlugName="CAF"
          recipient={recipient}
          onSaved={getRdvs}
        />
      ),
    });
  };

  const deleteRdv = (slotCalendarId) => {
    setDeletingRdvslotCalendarId(slotCalendarId);

    dataService.remove(
      `rdv/${slotCalendarId}`,
      {},
      () => {
        getRdvs();
        setDeletingRdvslotCalendarId(null);
      },
      setErrors,
      () => setDeletingRdvslotCalendarId(null)
    );
  };

  const orientationRdvs = rdvs.filter((rdv) =>
    [1, 2].includes(rdv.slotCalendar.type)
  );
  const cerRdvs = rdvs.filter((rdv) => rdv.slotCalendar.type == 3);

  const itemProps = {
    getReportDates,
    errors,
    rdvSlots,
    setOriginSelected,
    originSelected,
    reasonSelected,
    saveReportRdv,
    isSaved,
    isSaving,
    rdvSelected,
    rdspId,
    reportRdvOpen,
    isLoadingSlots,
    setReasonSelected,
    setRdvSelected,
    isReportSiteOpen,
    setIsReportSiteOpen,
    deleteRdv,
    deletingRdvslotCalendarId,
    getRdvs,
  };

  if (isLoading) return <Loader />;

  return (
    <div className="rdv-groups my-4">
      <section className="rdv-group" aria-labelledby="rdv-group-orientation">
        <div className="rdv-group__head">
          <h3 className="rdv-group__title" id="rdv-group-orientation">
            Rendez-vous d'orientation <Pill tone="muted">{orientationRdvs.length}</Pill>
          </h3>
        </div>
        {orientationRdvs.length === 0 ? (
          <EmptyState icon="fa-calendar-alt" title="Aucun rendez-vous d'orientation" />
        ) : (
          orientationRdvs.map((rdv, rdvk) => (
            <RecipientRdvListItem
              key={"rdvorientation" + rdvk}
              rdv={rdv}
              rdvIndex={rdvk}
              {...itemProps}
            />
          ))
        )}
      </section>

      <section className="rdv-group" aria-labelledby="rdv-group-cer">
        <div className="rdv-group__head">
          <h3 className="rdv-group__title" id="rdv-group-cer">
            Rendez-vous CER <Pill tone="muted">{cerRdvs.length}</Pill>
          </h3>
          <button type="button" className="btn btn-sm btn-ghost" onClick={openRdvOnTheFlyModal}>
            <i className="fa fa-plus mr-1" aria-hidden="true" />
            Créer un rendez-vous CER à la volée
          </button>
        </div>
        {cerRdvs.length === 0 ? (
          <EmptyState icon="fa-calendar-alt" title="Aucun rendez-vous CER" />
        ) : (
          cerRdvs.map((rdv, rdvk) => (
            <RecipientRdvListItem key={"rdvcer" + rdvk} rdv={rdv} rdvIndex={rdvk} {...itemProps} />
          ))
        )}
      </section>
    </div>
  );
};

export default RecipientRdv;
